// Stare linki portalu EBI sprzed wydzielenia (awiza i kod przywracania `/ebi/<slug>#<kod>` na domenie Magistratu).
// Portal działa dziś na platformie EBI (aplikacja ebi/). Moduł jest pierwszym importem main.tsx, więc rusza przed
// Sentry i Google Analytics — kod przywracania z fragmentu nie może trafić do ich zdarzeń ani nagrań.
// Z adresem portalu (VITE_APP_EBI_PORTAL_URL) przekierowujemy z zachowaniem ścieżki, zapytania i fragmentu;
// bez niego tylko zdejmujemy fragment z adresu (docelowo przekierowuje nginx — docs/ebi-separacja.md §5).

const LEGACY_PREFIX = /^\/ebi(?=\/|$)/;

/** Adres na platformie EBI dla starego linku albo `null`, gdy to nie jest link portalu albo nie ma adresu portalu. */
export const legacyEbiTarget = (portalUrl: string | undefined, pathname: string, search: string, hash: string) => {
  if (!LEGACY_PREFIX.test(pathname)) return null;

  const base = (portalUrl ?? "").trim().replace(/\/+$/, "");
  // https; http tylko dla lokalnego portalu (npm run dev:ebi)
  if (!/^(https:\/\/[^/]+|http:\/\/localhost(:\d+)?)$/i.test(base)) return null;

  return base + (pathname.replace(LEGACY_PREFIX, "") || "/") + search + hash;
};

/** Przekierowuje stary link portalu EBI; zwraca `true`, gdy przeglądarka przechodzi na platformę. */
export const redirectLegacyEbiLink = (
  portalUrl: string | undefined = import.meta.env.VITE_APP_EBI_PORTAL_URL,
  location: Location = window.location,
  history: History = window.history,
): boolean => {
  if (!LEGACY_PREFIX.test(location.pathname)) return false;

  const target = legacyEbiTarget(portalUrl, location.pathname, location.search, location.hash);

  // fragment znika z adresu od razu — także gdy przekierowanie jeszcze trwa albo adresu portalu brak
  if (location.hash) {
    history.replaceState(history.state, "", location.pathname + location.search);
  }

  if (!target) return false;

  location.replace(target);
  return true;
};

if (typeof window !== "undefined") {
  redirectLegacyEbiLink();
}
